import Container from '../../../components/container';
import soldaY from '../../../assets/images/services/solda-y.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import WhatsappContactLink from '../../../components/link/whatsapp-contact-link';

export default function About() {
	return (
		<Container className={'bg-accent w-full text-accent-content !py-0'}>
			<div className={'grid grid-cols-1 sm:grid-cols-3 gap-8'}>
				<div className={'col-span-1 w-full max-w-lg pt-8 sm:pt-0 relative justify-center sm:justify-end'}>
					<img className={'w-full'} src={soldaY} alt={'Imagem de Solda'}/>
				</div>

				<div className={'col-span-2 w-full pt-0 sm:pt-8'}>
					<p className={'text-xl sm:text-3xl pb-5'}>Sobre nós</p>
					<div className={'row-span-1 roboto text-xl space-y-4'}>
						<p>
							A <span className={'font-bold'}>FAST Soluções Industriais</span>, localizada em
							Forquilhinha – SC, nasceu com o propósito de oferecer
							<span
								className={'font-bold'}>{' '}soluções rápidas, eficientes e de alta qualidade{' '}</span>
							para o setor industrial.
						</p>
						<p>
							Somos especialistas em usinagem, solda, manutenção de peças industriais como cabeças de
							polimento e mancal de retífica.
						</p>
						<p>
							Com uma <span className={'font-bold'}>equipe técnica qualificada</span> e comprometida com
							<span className={'font-bold'}>{' '}resultados</span>, entregamos serviços precisos, prazos
							curtos
							e custo-benefício superior, ajudando nossos clientes a evitar paradas de produção, reduzir
							desperdícios e aumentar a <span className={'font-bold'}>eficiência operacional</span>.
						</p>
						<p>
							Mais do que uma prestadora de serviços, a FAST é uma parceira
							estratégica para o desempenho da sua indústria, garantindo atendimento ágil, soluções
							sob medida e suporte técnico sempre que você precisar.
						</p>

						<p>
							<span className={'font-bold'}>Fale conosco</span> agora pelo WhatsApp e
							solicite seu orçamento.
						</p>

						<div className={'flex justify-center pb-8 sm:block sm:pt-0'}>
							<WhatsappContactLink
								className={'btn btn-circle btn-success size-16 drop-shadow-xl shadow-lg'}>
								<FontAwesomeIcon size={'3x'} icon={faWhatsapp} color={'white'}/>
							</WhatsappContactLink>
						</div>
					</div>
				</div>
			</div>
		</Container>
	);
}